import { useEffect, useState, useContext } from "react";
import { LocalStoreContext } from "../store/LocalStore";
import { RefContext } from "../store/RefContext";
import { config as vsfpConfig } from "../../../d3charts/vsfp/config";
import { config } from "./config";
import { a, t1, t2, t4, t6, t12, t25 } from "./templates";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const rowStyle = { height: undefined, width: "100%" };

const headerStyle = {
  fontSize: 12,
  fontWeight: 600,
  width: `${100 / 25}%`,
  textAlign: "center",
  color: "grey",
};
const ColumnStyle = {
  color: "#919191",
  fontSize: 12,
  fontWeight: 600,
  textAlign: "center",
  border: "1px solid grey",
};

export const AverageTableView = () => {
  const [lstore] = useContext(LocalStoreContext);
  const refs = useContext(RefContext);
  const { filter, vsfpFiltered } = lstore;

  const [averageData, setAverageData] = useState();
  useEffect(() => {
    if (vsfpFiltered && vsfpFiltered.length > 0) {
      const sum = vsfpFiltered.reduce((a, b) => {
        return {
          ...a,
          [b["V-Score"]]: {
            s: (b["V-Score"] in a ? a[b["V-Score"]].s : 0) + b["FwdPxRet"],
            n: (b["V-Score"] in a ? a[b["V-Score"]].n : 0) + 1,
          },
        };
      }, {});

      const sum1 = Object.entries(sum).reduce((a, b) => {
        return {
          ...a,
          [t1[b[0]]]:
            t1[b[0]] in a
              ? { s: a[t1[b[0]]].s + b[1].s, n: a[t1[b[0]]].n + b[1].n }
              : { s: b[1].s, n: b[1].n },
        };
      }, {});

      const sum2 = Object.entries(sum).reduce((a, b) => {
        return {
          ...a,
          [t2[b[0]]]:
            t2[b[0]] in a
              ? { s: a[t2[b[0]]].s + b[1].s, n: a[t2[b[0]]].n + b[1].n }
              : { s: b[1].s, n: b[1].n },
        };
      }, {});

      const sum4 = Object.entries(sum).reduce((a, b) => {
        return {
          ...a,
          [t4[b[0]]]:
            t4[b[0]] in a
              ? { s: a[t4[b[0]]].s + b[1].s, n: a[t4[b[0]]].n + b[1].n }
              : { s: b[1].s, n: b[1].n },
        };
      }, {});

      const sum6 = Object.entries(sum).reduce((a, b) => {
        return {
          ...a,
          [t6[b[0]]]:
            t6[b[0]] in a
              ? { s: a[t6[b[0]]].s + b[1].s, n: a[t6[b[0]]].n + b[1].n }
              : { s: b[1].s, n: b[1].n },
        };
      }, {});

      const sum12 = Object.entries(sum).reduce((a, b) => {
        return {
          ...a,
          [t12[b[0]]]:
            t12[b[0]] in a
              ? { s: a[t12[b[0]]].s + b[1].s, n: a[t12[b[0]]].n + b[1].n }
              : { s: b[1].s, n: b[1].n },
        };
      }, {});

      const sum25 = Object.entries(sum).reduce((a, b) => {
        return {
          ...a,
          [t25[b[0]]]:
            t25[b[0]] in a
              ? { s: a[t25[b[0]]].s + b[1].s, n: a[t25[b[0]]].n + b[1].n }
              : { s: b[1].s, n: b[1].n },
        };
      }, {});

      const avg1 = Object.entries(sum1).reduce((a, b) => {
        return { ...a, [b[0]]: b[1].s / b[1].n };
      }, {});
      const avg2 = Object.entries(sum2).reduce((a, b) => {
        return { ...a, [b[0]]: b[1].s / b[1].n };
      }, {});
      const avg4 = Object.entries(sum4).reduce((a, b) => {
        return { ...a, [b[0]]: b[1].s / b[1].n };
      }, {});
      const avg6 = Object.entries(sum6).reduce((a, b) => {
        return { ...a, [b[0]]: b[1].s / b[1].n };
      }, {});
      const avg12 = Object.entries(sum12).reduce((a, b) => {
        return { ...a, [b[0]]: b[1].s / b[1].n };
      }, {});
      const avg25 = Object.entries(sum25).reduce((a, b) => {
        return { ...a, [b[0]]: b[1].s / b[1].n };
      }, {});

      setAverageData({
        1: avg1,
        2: avg2,
        4: avg4,
        6: avg6,
        12: avg12,
        25: avg25,
      });
    } else {
      setAverageData(null);
    }
  }, [vsfpFiltered]);

  return averageData ? (
    <div
      style={{
        height: refs.componentSize.current["AverageTableView"].height,
        width: refs.componentSize.current["AverageTableView"].width,
        margin: 0,
        paddingRight: vsfpConfig.layout.margin.right,
        paddingLeft: vsfpConfig.layout.margin.left,
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#D4D4D4",
          padding: 10,
        }}
      >
        {`Average Forward ${(+filter.Horizon[0]).toFixed(
          0
        )}d Price Return by V-Score`}
      </div>
      <div style={{ display: "inline-block", width: "100%" }}>
        <table style={tableStyle} className="stripes">
          <thead>
            <tr style={rowStyle}>
              {a.map((item, i) => {
                return (
                  <td key={`h${i}`} style={headerStyle}>
                    {item}
                  </td>
                );
              })}
            </tr>
          </thead>
          <tbody>
            <tr style={rowStyle}>
              {a.map((tditem, i) => {
                return (
                  <td key={`c1${i}`} style={ColumnStyle}>
                    {averageData["1"][i]
                      ? averageData["1"][i].toFixed(config.decimalPlaces)
                      : undefined}
                  </td>
                );
              })}
            </tr>
            <tr style={rowStyle}>
              {a
                .filter((item, i) => {
                  return i < 13;
                })
                .map((tditem, i) => {
                  const i2 = i % 13;
                  return (
                    <td
                      key={`c2${i}`}
                      style={ColumnStyle}
                      colSpan={i2 === 6 ? undefined : 2}
                    >
                      {averageData["2"][i2]
                        ? averageData["2"][i2].toFixed(config.decimalPlaces)
                        : undefined}
                    </td>
                  );
                })}
            </tr>
            <tr style={rowStyle}>
              {a
                .filter((item, i) => {
                  return i < 7;
                })
                .map((tditem, i) => {
                  const i4 = i % 7;
                  return (
                    <td
                      key={`c4${i}`}
                      style={ColumnStyle}
                      colSpan={i4 === 3 ? undefined : 4}
                    >
                      {averageData["4"][i4]
                        ? averageData["4"][i4].toFixed(config.decimalPlaces)
                        : undefined}
                    </td>
                  );
                })}
            </tr>
            <tr style={rowStyle}>
              {a
                .filter((item, i) => {
                  return i < 5;
                })
                .map((tditem, i) => {
                  const i6 = i % 5;
                  return (
                    <td
                      key={`c6${i}`}
                      style={ColumnStyle}
                      colSpan={i6 === 2 ? undefined : 6}
                    >
                      {averageData["6"][i6]
                        ? averageData["6"][i6].toFixed(config.decimalPlaces)
                        : undefined}
                    </td>
                  );
                })}
            </tr>

            <tr style={rowStyle}>
              {a
                .filter((item, i) => {
                  return i < 3;
                })
                .map((tditem, i) => {
                  const i12 = i % 3;
                  return (
                    <td
                      key={`c12${i}`}
                      style={ColumnStyle}
                      colSpan={i12 === 1 ? undefined : 12}
                    >
                      {averageData["12"][i12]
                        ? averageData["12"][i12].toFixed(config.decimalPlaces)
                        : undefined}
                    </td>
                  );
                })}
            </tr>

            <tr style={rowStyle}>
              {a
                .filter((item, i) => {
                  return i === 0;
                })
                .map((tditem, i) => {
                  return (
                    <td key={`c25${i}`} style={ColumnStyle} colSpan={25}>
                      {averageData["25"][0]
                        ? averageData["25"][0].toFixed(config.decimalPlaces)
                        : undefined}
                    </td>
                  );
                })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  ) : null;
};
